import { TelefoneComTipoFields } from 'app/modules/apps/shared/telefone/TelefoneComTipoFields'
import { opcaoTipoTelefone } from 'app/modules/apps/shared/telefone/tipoTelefone'
import { TipoLogradouroPaisFields } from 'app/modules/apps/shared/endereco/TipoLogradouroPaisFields'
import {
  dtoTipoLogradouroPais,
  valoresIniciaisTipoLogradouroPais,
} from 'app/modules/apps/shared/endereco/tipoLogradouroPais'
import { setNestedObjectValues, useFormik } from 'formik'
import { FC, FormEvent, useEffect, useMemo, useState } from 'react'
import { DocumentosPessoaForm } from 'app/modules/apps/shared/documentos-pessoa/DocumentosPessoaForm'
import { IdentificadoresPessoaFields } from 'app/modules/apps/shared/documentos-pessoa/IdentificadoresPessoaFields'
import { DocumentoPessoa } from 'app/modules/apps/shared/documentos-pessoa/_models'
import {
  dtoDocumentoEstrangeiro,
  temDocumentoEstrangeiro,
  valoresIniciaisIdentificadores,
} from 'app/modules/apps/shared/documentos-pessoa/identificadores'
import {
  apenasDigitos,
  ButtonType,
  CargoType,
  GenderType,
  GeneroType,
  IconPaths,
  IconSize,
  MaskType,
  OptionsHelper,
  Permission,
  RacaType,
  showAlert,
  applyApiFieldErrors,
  showError,
  VinculoLabels,
} from '../../../../../../../_metronic/helpers'
import {
  createFuncionario,
  updateFuncionario,
  updateEnderecoFuncionario,
  createEnderecoFuncionario,
  updateDadosAdicionaisFuncionarios,
  documentosFuncionarioRequests,
} from '../../core/_requests'
import {
  confirmarReprocessamentoFaturas,
  usePermissaoReprocessarFaturas,
  valoresProfissionalAlterados,
} from '../../core/_reprocessamentoFaturas'
import Swal from 'sweetalert2'
import { reenvioTokenConfirm, requestPassword } from '../../../../../auth/core/_requests'
import {
  Button,
  ButtonIcon,
  coletarMensagensErro,
  CustomAccordion,
  FetchState,
  FormDateInput,
  FormInput,
  FormSelect,
  FormTextArea,
  IOption,
  ListLoading,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import {
  FuncionarioDtoCreate,
  FuncionarioDtoDadosAdicionais,
  FuncionarioDtoUpdate,
  FuncionarioView,
} from '../../core/_models'
import {
  EnderecoDtoCreate,
  EnderecoDtoUpdate,
  EnderecoList,
} from '../../../../empresa/empresas-list/core/_models'
import { funcionarioSchema } from './validation/funcionarioSchema'
import {
  DadosAdicionaisProfissionalFields,
  dtoDadosAdicionaisProfissional,
  valoresIniciaisDadosAdicionaisProfissional,
} from './DadosAdicionaisProfissionalFields'
import { getEstadoByUf } from '../../../../atendimento_medicos/atendimentos-medico-list/core/_requests'
import { getUnidades } from '../../../../unidades/unidades-list/core/_requests'
import { PasswordDtoRecover, useAuth } from '../../../../../auth'
import {
  getGenerosByName,
  getRacasByName,
} from '../../../../../../../_metronic/helpers/crud-helper/_request'
import { IInfo } from '../../../../../../components/Modal/SearchPersonModal'
import { useT } from '_metronic/i18n/Metronici18n'
import { isConselhoMedicina } from 'app/modules/apps/admin/profissionais-saude/profissional-saude/core/_conselho'
import { ConselhosModal } from 'app/modules/apps/admin/profissionais-saude/profissional-saude/components/modal/ConselhosModal'
import { getConselhos } from 'app/modules/apps/admin/profissionais-saude/profissional-saude/core/_requests'

type IProps = {
  info?: IInfo
}

export const FuncionarioModal: FC<IProps> = ({ info }) => {
  const { currentUser } = useAuth()
  const { fetchStates, closeModal, showModal } = useModal()
  const { t } = useT()

  const { data: funcionario } = (fetchStates['funcionario'] || {}) as FetchState<FuncionarioView>

  const { data: endereco } = (fetchStates['endereco'] || {}) as FetchState<EnderecoList>
  const { data: unidades } = (fetchStates['unidades'] || {}) as FetchState<IOption<number>[]>

  const [showEndereco, setShowEndereco] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [optionsUnidades, setOptionsUnidades] = useState<IOption<number>[]>()

  const isAdmin = currentUser?.grupo?.nome === Permission.SuperAdmin
  const podeReprocessarFaturas = usePermissaoReprocessarFaturas()

  // Documentos da lista (RG, passaporte, CTPS, BI): passaporte/BI ali já identificam a pessoa.
  const [documentosLista, setDocumentosLista] = useState<DocumentoPessoa[]>([])
  const documentoEstrangeiroNaLista = temDocumentoEstrangeiro(documentosLista)

  const initialValues = {
    funcionario: {
      id: funcionario?.id,
      primeiroNome: info?.primeiroNome || funcionario?.pessoa?.primeiroNome || '',
      sobreNome: info?.sobreNome || funcionario?.pessoa?.sobreNome || '',
      nomeSocial: funcionario?.pessoa?.nomeSocial || '',
      ...valoresIniciaisIdentificadores(
        funcionario?.pessoa?.cpf,
        funcionario?.pessoa?.cns,
        funcionario ? undefined : info?.documento
      ),
      justificativa: '',

      uf: undefined as IOption<string> | undefined,
      telefone: funcionario?.pessoa?.telefone || '',
      tipoTelefone: opcaoTipoTelefone(t, funcionario?.pessoa?.tipoTelefone),
      sexo: funcionario?.pessoa
        ? {
            label: funcionario.pessoa.sexo === GenderType.Feminino ? 'Feminino' : 'Masculino',
            value: funcionario.pessoa.sexo,
          }
        : (undefined as IOption<GenderType> | undefined),
      nascimento: info?.dataNascimento || funcionario?.pessoa?.dataNascimento || '',
      crm: funcionario?.crm || '',
      email: funcionario?.pessoa?.usuario?.email || '',

      rqe: funcionario?.rqe || '',

      vinculo: funcionario?.vinculo
        ? { label: VinculoLabels[funcionario.vinculo], value: funcionario.vinculo }
        : undefined,

      conselho: funcionario?.conselho
        ? {
            label: `${funcionario.conselho.sigla} - ${funcionario.conselho.nome}`,
            value: funcionario.conselho.id,
          }
        : undefined,

      cargo: funcionario?.cargo
        ? {
            label:
              funcionario.cargo === CargoType.Medico
                ? 'Profissional de Saúde'
                : funcionario?.cargo.charAt(0).toUpperCase() +
                  funcionario?.cargo.slice(1).toLowerCase(),
            value: funcionario.cargo,
          }
        : (undefined as IOption<CargoType> | undefined),
      especialidades: funcionario?.especialidades
        ? funcionario.especialidades.map((especialidade) => ({
            value: especialidade.id,
            label: especialidade.nome,
          }))
        : (undefined as IOption<number>[] | undefined),
      unidades: funcionario?.unidades
        ? OptionsHelper.createOptions(funcionario.unidades || [], 'nome', 'id')
        : (undefined as IOption<number>[] | undefined),
      raca: undefined as IOption<RacaType> | undefined,
      genero: undefined as IOption<GeneroType> | undefined,
      nacionalidade: funcionario?.dadosAdicionais?.nacionalidade
        ? {
            label: funcionario?.dadosAdicionais?.nacionalidade.descricao,
            value: funcionario?.dadosAdicionais?.nacionalidade.id,
          }
        : undefined,
      faturamentoMinimo: funcionario?.faturamentoMinimo,
      valorAtendimento: funcionario?.valorAtendimento,
      valorRetorno: funcionario?.valorRetorno,
      ...valoresIniciaisDadosAdicionaisProfissional(funcionario?.dadosAdicionais),
    },
    empresa: funcionario?.empresa
      ? {
          label: funcionario.empresa?.nomeFantasia,
          value: funcionario.empresa?.id,
        }
      : (undefined as IOption<number> | undefined),

    // endereço
    endereco: {
      cep: endereco?.cep || '',
      logradouro: endereco?.logradouro || '',
      numero: endereco?.numero || '',
      complemento: endereco?.complemento || '',
      bairro: endereco?.bairro || '',
      cidade: endereco?.cidade || '',
      uf: undefined as IOption<string> | undefined,
      ...valoresIniciaisTipoLogradouroPais(endereco),
    },
  }

  const reenviarConfirmacao = async () => {
    if (funcionario?.pessoa?.usuario !== undefined)
      if (!funcionario?.pessoa?.usuario.confirmado) {
        try {
          await reenvioTokenConfirm(funcionario?.pessoa?.usuario.id)
          showAlert({
            title: 'Sucesso!',
            text: 'Reenvio do Token enviado com sucesso!',
            icon: 'success',
          })
        } catch (error) {
          showError(error)
        }
      } else {
        const result = await Swal.fire({
          title: 'Conta já confirmada!',
          text:
            'Deseja recadastrar a senha? Um e-mail será enviado para:' +
            funcionario?.pessoa?.usuario.email,
          icon: 'warning',
          buttonsStyling: false,
          showCancelButton: true,
          cancelButtonText: 'Não',
          confirmButtonText: 'Sim',
          reverseButtons: true,
          customClass: {
            cancelButton: 'btn btn-secondary',
            confirmButton: 'btn btn-primary',
          },
        })
        if (result.isConfirmed) {
          try {
            const data: PasswordDtoRecover = {
              email: String(funcionario.pessoa.usuario.email),
            }
            await requestPassword(data)
            showAlert({
              title: 'Sucesso',
              text: 'Solicitação realizada com sucesso!',
              icon: 'success',
            })
          } catch (error) {
            showError(error)
          }
        }
      }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: useMemo(
      () =>
        funcionarioSchema(
          t,
          showEndereco,
          !!funcionario,
          documentoEstrangeiroNaLista,
          initialValues.funcionario.cpf,
          initialValues.funcionario.cns
        ),
      [
        t,
        showEndereco,
        funcionario,
        documentoEstrangeiroNaLista,
        initialValues.funcionario.cpf,
        initialValues.funcionario.cns,
      ]
    ),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        let result
        const espec = values.funcionario.especialidades
          ? values.funcionario.especialidades.map((espe) => Number(espe.value) as number)
          : null

        const dadosAdicionais: FuncionarioDtoDadosAdicionais = {
          genero: values.funcionario.genero?.value,
          nacionalidade: values.funcionario.nacionalidade?.value,
          raca: values.funcionario.raca?.value,
          ...dtoDadosAdicionaisProfissional(values.funcionario),
        }

        if (values.funcionario.id) {
          const documentoAlterado =
            apenasDigitos(values.funcionario.cpf) !==
              apenasDigitos(initialValues.funcionario.cpf) ||
            apenasDigitos(values.funcionario.cns) !== apenasDigitos(initialValues.funcionario.cns)

          const func: FuncionarioDtoUpdate = {
            cargo: values.funcionario.cargo?.value as CargoType,
            crm: values.funcionario.crm || undefined,
            rqe: isConselhoMedicina(values.funcionario.conselho)
              ? values.funcionario.rqe || undefined
              : undefined,
            uf: values.funcionario.uf?.value || undefined,
            pessoa: {
              id: funcionario?.pessoa?.id as number,
              primeiroNome: values.funcionario.primeiroNome,
              sobreNome: values.funcionario.sobreNome,
              nomeSocial: values.funcionario.nomeSocial || undefined,
              cpf: values.funcionario.cpf || undefined,
              cns: values.funcionario.cns || undefined,
              ...dtoDocumentoEstrangeiro(values.funcionario, documentoEstrangeiroNaLista),
              telefone: values.funcionario.telefone || undefined,
              tipoTelefone: values.funcionario.tipoTelefone?.value,
              nascimento: values.funcionario.nascimento,
              sexo: values.funcionario.sexo?.value as GenderType,
              justificativa: documentoAlterado
                ? values.funcionario.justificativa || undefined
                : undefined,
            },
            email: values.funcionario.email,
            especialidades: !!espec ? espec : undefined,
            unidades: values.funcionario.unidades
              ? values.funcionario.unidades.map((item) => Number(item.value))
              : undefined,
            vinculo: values.funcionario.vinculo?.value || undefined,
            conselho: values.funcionario.conselho?.value || undefined,
            faturamentoMinimo: values.funcionario.faturamentoMinimo || null,
            valorAtendimento: values.funcionario.valorAtendimento,
            valorRetorno: values.funcionario.valorRetorno,
          }

          // LO-1373: só pergunta se mexeu no valor do atendimento/retorno e se o grupo tem
          // Financeiro:write — sem a permissão, "sim" derrubaria a gravação inteira com 403.
          const reprocessarFaturas =
            podeReprocessarFaturas &&
            valoresProfissionalAlterados(values.funcionario, initialValues.funcionario)
              ? await confirmarReprocessamentoFaturas()
              : false

          await updateDadosAdicionaisFuncionarios(values.funcionario.id, dadosAdicionais)
          result = await updateFuncionario(
            values.funcionario.id as number,
            func,
            reprocessarFaturas
          )
        } else {
          const func: FuncionarioDtoCreate = {
            primeiroNome: values.funcionario.primeiroNome,
            sobreNome: values.funcionario.sobreNome,
            nomeSocial: values.funcionario.nomeSocial || undefined,
            cpf: values.funcionario.cpf || undefined,
            cns: values.funcionario.cns || undefined,
            email: values.funcionario.email,
            telefone: values.funcionario.telefone || undefined,
            tipoTelefone: values.funcionario.tipoTelefone?.value,
            ...dtoDocumentoEstrangeiro(values.funcionario, false),
            sexo: values.funcionario.sexo?.value as GenderType,
            nascimento: values.funcionario.nascimento,
            cargo: values.funcionario.cargo?.value as CargoType,
            crm: values.funcionario.crm || undefined,
            rqe: isConselhoMedicina(values.funcionario.conselho)
              ? values.funcionario.rqe || undefined
              : undefined,
            uf: values.funcionario.uf?.value || undefined,
            especialidades: !!espec ? espec : undefined,
            unidades: values.funcionario.unidades
              ? values.funcionario.unidades.map((item) => Number(item.value))
              : undefined,
            vinculo: values.funcionario.vinculo?.value || undefined,
            conselho: values.funcionario.conselho?.value || undefined,
            dadosAdicionais,
            faturamentoMinimo: values.funcionario.faturamentoMinimo || null,
            valorAtendimento: values.funcionario.valorAtendimento,
            valorRetorno: values.funcionario.valorRetorno,
          }

          result = await createFuncionario(values.empresa?.value as number, func)

          /* if (isMedico && certificadoValue) {
              await persistCertificadoAdmin(result?.id, certificadoValue)
            } */
        }
        if (showEndereco) {
          if (endereco) {
            const address: EnderecoDtoUpdate = {
              id: endereco?.id as number,
              cep: values.endereco.cep,
              logradouro: values.endereco.logradouro,
              numero: values.endereco.numero,
              complemento: values.endereco.complemento ? values.endereco.complemento : null,
              bairro: values.endereco.bairro,
              cidade: values.endereco.cidade,
              uf: values.endereco.uf?.value as string,
              ...dtoTipoLogradouroPais(values.endereco),
            }
            await updateEnderecoFuncionario(funcionario?.id, address)
          } else {
            const address: EnderecoDtoCreate = {
              tipo: 1,
              cep: values.endereco.cep,
              logradouro: values.endereco.logradouro,
              numero: values.endereco.numero,
              complemento: values.endereco.complemento ? values.endereco.complemento : null,
              bairro: values.endereco.bairro,
              cidade: values.endereco.cidade,
              uf: values.endereco.uf?.value as string,
              ...dtoTipoLogradouroPais(values.endereco),
            }
            await createEnderecoFuncionario(result.id, address)
          }
        }

        await showAlert({
          title: 'Sucesso!',
          text: values.funcionario.id
            ? 'Funcionário atualizado com sucesso!'
            : 'Funcionário cadastrado com sucesso!',
          icon: 'success',
        })
        closeModal()
      } catch (error) {
        const temOutroErro = applyApiFieldErrors(
          error,
          (campo, mensagem) => formik.setFieldError(`funcionario.${campo}`, mensagem),
          ['cpf', 'cns', 'crm', 'uf', 'email']
        )
        if (temOutroErro) showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  /**
   * Sem isso o submit vira um no-op silencioso quando o campo reprovado não
   * está renderizado (ex.: CEP com a seção de endereço fechada): o Formik
   * bloqueia o envio e nenhum `ErrorLabel` aparece em tela.
   */
  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const errors = await formik.validateForm()
    const mensagens = coletarMensagensErro(errors)

    if (mensagens.length > 0) {
      formik.setTouched(setNestedObjectValues(errors, true))
      showAlert({
        title: 'Verifique o formulário',
        icon: 'warning',
        html: `<ul class='text-start'>${mensagens.map((msg) => `<li>${msg}</li>`).join('')}</ul>`,
      })
      return
    }

    formik.handleSubmit(event)
  }

  const empresaId = formik.values.empresa?.value
  const { setFieldValue } = formik

  useEffect(() => {
    const fetchData = async () => {
      if (funcionario?.dadosAdicionais?.genero) {
        const genero = await getGenerosByName(funcionario?.dadosAdicionais?.genero)
        setFieldValue('funcionario.genero', { label: genero.descricao, value: genero.name })
      }
      if (funcionario?.dadosAdicionais?.raca) {
        const raca = await getRacasByName(funcionario?.dadosAdicionais?.raca)
        setFieldValue('funcionario.raca', { label: raca.descricao, value: raca.name })
      }

      if (endereco?.uf) {
        const ufEnd = await getEstadoByUf(endereco.uf)
        setFieldValue('endereco.uf', { label: ufEnd.descricao, value: ufEnd.sigla })
      }

      if (funcionario?.crm && funcionario?.uf) {
        const ufCrm = await getEstadoByUf(funcionario.uf)
        setFieldValue('funcionario.uf', { label: ufCrm.descricao, value: ufCrm.sigla })
      }
    }

    fetchData()

    setIsLoading(false)
  }, [
    endereco?.uf,
    funcionario?.crm,
    funcionario?.dadosAdicionais?.genero,
    funcionario?.dadosAdicionais?.raca,
    funcionario?.uf,
    setFieldValue,
  ])

  useEffect(() => {
    const fetchUnidadesByEmpresa = async () => {
      try {
        setIsLoading(true)
        const resp = await getUnidades(`page=0&size=100&search=&idEmpresa=${empresaId}`)
        setOptionsUnidades(OptionsHelper.createOptions(resp.data || [], 'nome', 'id'))
      } catch (error) {
        showError(error)
      } finally {
        setIsLoading(false)
      }
    }

    if (empresaId && !unidades) fetchUnidadesByEmpresa()
  }, [empresaId, unidades])

  const showVinculo =
    formik.values.funcionario.cargo?.value === CargoType.Medico &&
    (currentUser?.grupo?.nome === Permission.SuperAdmin ||
      currentUser?.grupo?.nome === Permission.SuperMedico)

  const documentoAlterado =
    !!funcionario &&
    (apenasDigitos(formik.values.funcionario.cpf) !==
      apenasDigitos(initialValues.funcionario.cpf) ||
      apenasDigitos(formik.values.funcionario.cns) !== apenasDigitos(initialValues.funcionario.cns))

  const openConselhosModal = () => {
    showModal({
      title: 'Gerenciar Conselhos',
      content: <ConselhosModal />,
      fetchers: {
        conselhos: () => getConselhos(),
      },
    })
  }

  return (
    <>
      {info?.documento?.numero && (
        <div className='alert alert-warning'>
          <div className='alert-text font-weight-bold'>Funcionário não possui cadastro.</div>
        </div>
      )}
      <form onSubmit={handleSubmit} noValidate>
        <div className='row mb-3'>
          <div className='col-md-6'>
            <FormSelect
              formik={formik}
              name='empresa'
              entity='empresa'
              fetchOptions={OptionsHelper.getOptionsEmpresas}
              isClearable={false}
              isDisabled={!!funcionario}
              isRequired
            />
          </div>
          <div className='col-md-6'>
            <FormSelect
              formik={formik}
              name='funcionario.cargo'
              entity='cargo'
              fetchOptions={OptionsHelper.getOptionsCargos}
              isClearable={false}
              isDisabled={formik.isSubmitting}
              isRequired
            />
          </div>
        </div>
        {formik.values.funcionario.cargo?.value === CargoType.Medico &&
          ((unidades && unidades.length > 0) ||
            (optionsUnidades && optionsUnidades.length > 0)) && (
            <FormSelect
              formik={formik}
              options={funcionario ? unidades : optionsUnidades}
              name='funcionario.unidades'
              entity='unidade_setor'
              isDisabled={formik.isSubmitting}
              isMulti
              className='mb-3'
            />
          )}

        {formik.values.funcionario.cargo?.value === CargoType.Medico && (
          <FormSelect
            formik={formik}
            name='funcionario.especialidades'
            entity='especialidade'
            fetchOptions={OptionsHelper.getOptionsEspecialidades}
            className='mb-3'
            isDisabled={formik.isSubmitting}
            isMulti
          />
        )}
        {showVinculo && (
          <FormSelect
            formik={formik}
            name='funcionario.vinculo'
            entity='vinculo'
            fetchOptions={OptionsHelper.getOptionsTiposVinculos}
            isDisabled={formik.isSubmitting}
            className='mb-3'
          />
        )}
        <div className='row mb-3'>
          <div className='col-md-6'>
            <FormInput
              formik={formik}
              name='funcionario.primeiroNome'
              entity='primeiroNome'
              isRequired
            />
          </div>
          <div className='col-md-6'>
            <FormInput formik={formik} name='funcionario.sobreNome' entity='sobrenome' isRequired />
          </div>
        </div>
        <FormInput
          formik={formik}
          name='funcionario.nomeSocial'
          entity='nome_social'
          className='mb-3'
          isDisabled={formik.isSubmitting}
        />
        <IdentificadoresPessoaFields
          formik={formik}
          prefixo='funcionario.'
          cpf={formik.values.funcionario.cpf}
          cns={formik.values.funcionario.cns}
          documentoEstrangeiroNaLista={documentoEstrangeiroNaLista}
          idPrefix='funcionario'
        />
        {documentoAlterado && (
          <FormTextArea
            formik={formik}
            name='funcionario.justificativa'
            entity='justificativa_cpf_cns'
            placeholder='Descreva o motivo da alteração do CPF/CNS'
            className='mb-3'
            isRequired
          />
        )}
        <div className='row mb-3'>
          <div className='col-md-6'>
            <TelefoneComTipoFields formik={formik} prefixo='funcionario.' idPrefix='funcionario' />
          </div>
          <div className='col-md-6'>
            <FormInput formik={formik} name='funcionario.email' entity='email' isRequired />
          </div>
        </div>

        {formik.values.funcionario.cargo?.value === CargoType.Medico && (
          <div className='row'>
            <div className='d-flex align-items-end mb-3'>
              <FormSelect
                formik={formik}
                name='funcionario.conselho'
                entity='conselho'
                fetchOptions={OptionsHelper.getOptionsConselhos}
                className='flex-grow-1'
                isDisabled={formik.isSubmitting}
                isRequired
              />
              {isAdmin && (
                <ButtonIcon
                  icon={IconPaths.Gear}
                  iconSize={IconSize.Small}
                  onClick={openConselhosModal}
                  disabled={formik.isSubmitting}
                />
              )}
            </div>
            {isConselhoMedicina(formik.values.funcionario.conselho) && (
              <div className='col-md-6 mb-3'>
                <FormInput formik={formik} name='funcionario.rqe' entity='rqe' />
              </div>
            )}

            <div className='col-md-6 mb-3'>
              <FormInput
                formik={formik}
                name='funcionario.crm'
                entity='registro_conselho'
                isRequired
              />
            </div>
            <div className='col-md-6 mb-3'>
              <FormSelect
                formik={formik}
                name='funcionario.uf'
                entity='estado'
                fetchOptions={OptionsHelper.getOptionsEstadosUf}
                isClearable={false}
                isDisabled={formik.isSubmitting}
                isRequired
              />
            </div>

            <div className='col-md-6 mb-3'>
              <FormInput
                formik={formik}
                type='number'
                name='funcionario.faturamentoMinimo'
                placeholder='Quantidade mínima de atendimentos mensais'
                label='Mínimo de atendimentos'
                infoText={t('minimo_atendimentos.infotext')}
                highlight
              />
            </div>
            <div className='col-md-6 mb-3'>
              <FormInput
                formik={formik}
                type='number'
                name='funcionario.valorAtendimento'
                entity='valor_padrao_atendimento'
                infoText={t('valor_padrao_atendimento.infotext')}
                highlight
              />
            </div>
            <div className='col-md-6 mb-3'>
              <FormInput
                formik={formik}
                type='number'
                name='funcionario.valorRetorno'
                entity='valor_retorno'
              />
            </div>
          </div>
        )}

        <div className='row mb-3'>
          <div className='col-md-6'>
            <FormSelect
              formik={formik}
              name='funcionario.sexo'
              entity='sexo'
              options={OptionsHelper.generos}
              isClearable={false}
              isDisabled={formik.isSubmitting}
              isRequired
            />
          </div>
          <div className='col-md-6'>
            <FormDateInput
              formik={formik}
              name='funcionario.nascimento'
              entity='data_nascimento'
              maxDate={new Date()}
              isRequired
            />
          </div>
        </div>

        <div className='row my-5'>
          <h2>{t('documento_pessoa.titulo')}</h2>
        </div>
        <DocumentosPessoaForm
          ownerId={funcionario?.id ? Number(funcionario.id) : undefined}
          recurso='funcionario'
          requests={documentosFuncionarioRequests}
          onChange={setDocumentosLista}
        />

        <CustomAccordion title={t('dado_adicional.plural')}>
          <div className='row my-5'>
            <h2>{t('informacao_adicional.plural')}</h2>
          </div>

          <div className='row mb-3'>
            <div className='col-md-6'>
              <FormSelect
                formik={formik}
                name='funcionario.raca'
                entity='raca'
                fetchOptions={OptionsHelper.getOptionsRacas}
                isDisabled={formik.isSubmitting}
              />
            </div>
            <div className='col-md-6'>
              <FormSelect
                formik={formik}
                name='funcionario.genero'
                entity='genero'
                fetchOptions={OptionsHelper.getOptionsGeneros}
                isDisabled={formik.isSubmitting}
              />
            </div>
          </div>
          <FormSelect
            formik={formik}
            name='funcionario.nacionalidade'
            entity='nacionalidade'
            fetchOptions={OptionsHelper.getOptionsNacionalidades}
            isDisabled={formik.isSubmitting}
            className='mb-3'
          />
          <DadosAdicionaisProfissionalFields
            formik={formik}
            estadoNascimentoInicial={funcionario?.dadosAdicionais?.estadoNascimento}
            idPrefix='funcionario'
          />
        </CustomAccordion>

        {showEndereco && (
          <>
            <div className='row my-5'>
              <h2>{t('endereco.label')}</h2>
            </div>
            <TipoLogradouroPaisFields
              formik={formik}
              prefixo='endereco.'
              novo={!endereco}
              idPrefix='funcionario-endereco'
            />
            <div className='row mb-3'>
              <div className='col-md-8'>
                <FormInput formik={formik} name='endereco.logradouro' entity='logradouro' />
              </div>
              <div className='col-md-4'>
                <FormInput formik={formik} name='endereco.numero' entity='numero' />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-8'>
                <FormInput formik={formik} name='endereco.complemento' entity='complemento' />
              </div>
              <div className='col-md-4'>
                <FormInput formik={formik} name='endereco.cep' entity='cep' mask={MaskType.CEP} />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-8'>
                <FormInput formik={formik} name='endereco.bairro' entity='bairro' />
              </div>
              <div className='col-md-4'>
                <FormInput formik={formik} name='endereco.cidade' entity='cidade' />
              </div>
            </div>

            <FormSelect
              formik={formik}
              name='endereco.uf'
              entity='estado'
              fetchOptions={OptionsHelper.getOptionsEstadosUf}
              isClearable={false}
              isDisabled={formik.isSubmitting}
            />
          </>
        )}

        <div className='d-flex flex-end my-4'>
          <Button
            className='btn-primary'
            onClick={() => setShowEndereco((prev) => !prev)}
            disabled={formik.isSubmitting || isLoading}
            size='btn-sm'
          >
            {endereco
              ? showEndereco
                ? 'Esconder Endereço'
                : 'Ver Endereço'
              : showEndereco
              ? 'Remover Endereço'
              : 'Adicionar Endereço'}
          </Button>
        </div>
        {funcionario && (
          <div className='row my-4'>
            <div className='d-flex col-lg-4 ms-auto'>
              <Button
                type={ButtonType.Reset}
                onClick={reenviarConfirmacao}
                className='btn-secondary w-100'
                disabled={formik.isSubmitting || isLoading}
              >
                Reenviar token
              </Button>
            </div>
          </div>
        )}

        <div className='d-flex justify-content-center mt-8'>
          <Button
            type={ButtonType.Reset}
            onClick={closeModal}
            className='btn-secondary me-3'
            disabled={formik.isSubmitting || isLoading}
          >
            {t('common.cancel')}
          </Button>

          <Button
            type={ButtonType.Submit}
            className='btn-primary'
            disabled={formik.isSubmitting || isLoading}
          >
            {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
          </Button>
        </div>
      </form>
      {(formik.isSubmitting || isLoading) && <ListLoading />}
    </>
  )
}
